export default "__VITE_ASSET__DBjhhQoa__"